module.exports = __webpack_public_path__ + "img/line.dcebce05.png";